import React, { Component } from "react";

import Jumbotron from "../utils/Jumbotron";

import Layout from "../header_footer/Layout";

import "./pontosInteresse.css";

import PontoInteresseSmall from "./PontoInteresseSmall";

import PropTypes from 'prop-types';
import axios from 'axios';

class PontosInteresse extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      pontosInteresse: []
    };
  }

  componentDidMount = () => {
    this.loadPontos();
  }

  loadPontos = async () => {
    
    let res = {};
    try{

      res = await axios.get('api/pontosInteresse', {
        params: {
          'type': 'PONTO_INTERESSE',
          'limit': 0
        },
        headers: {
          'APIKEY': 'q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf',
          'Content-Type': 'application/json'
        }
      });

    } catch(error){
      console.log(error);
    }
    
    let pontosInteresse = res.data.arrayPontos;

    this.setState({pontosInteresse: pontosInteresse});

  }

  POIClicked = (identifier) => {
    this.context.router.history.push("/pontos_interesse/" + identifier);
  }

  render() {

    const items = this.state.pontosInteresse.map((item) => {
      return <PontoInteresseSmall POIClicked={this.POIClicked} item={item} key={item.name}></PontoInteresseSmall>;
    });

    return (
      <Layout>
        <Jumbotron title={"A aldeia"}></Jumbotron>

        <div className="container">
          <div className="padding-right-small row justify-content-center">
            <div className="col-12 col-md-10">
            {items}
            </div>
          </div>
        </div>

      </Layout>
    );
  }
}

export default PontosInteresse;
